const LoanApplicationTableAsignTo = ["mohit@credfin.money","mohit@abhicash.in","mohit@micromoney.in"]
const changeLeadStatusNotcheck = ["accounts@credfin.money","accounts@micromoney.in","accounts@abhicash.in"]
const CRIFRegenrateButtonCheck = ["SuperUser","vansh@credfin.money","karan@micromoney.in","vicky.rawani@abhicash.in","vikas.kumar@abhicash.in"]
const GenerateReportcheck = ["shubham.goyal@credfin.money","harshit@credfin.money","mohit.bansal@credfin.money","fahad@credfin.money","arsad@abhicash.in","nisha.gayal@abhicash.in","tanima.ghosh@abhicash.in","vicky.rawani@abhicash.in","shashank.saxena@abhicash.in","mohit.bansal@abhicash.in","karan@micromoney.in","mohit.bansal@micromoney.in","riya@credfin.money","vikas.kumar@abhicash.in"]
const AADHARRegenrateCheck = ["siddhart@abhicash.in"]
const CustomLeadManagementAllDataListShow = ["siddhart@abhicash.in","tanima.ghosh@abhicash.in","nisha.gayal@abhicash.in"]

const EmailcheckFn = (email , checkArray)=>{
    if(checkArray.includes(email)){
        return true
    }
    return false
}
const EmailNotcheckFn = (email , checkArray)=>{
    if(!checkArray.includes(email)){
        return true
    }
    return false
}


export {
    EmailcheckFn,EmailNotcheckFn,
    LoanApplicationTableAsignTo,
    changeLeadStatusNotcheck,
    CRIFRegenrateButtonCheck,
    GenerateReportcheck,AADHARRegenrateCheck, CustomLeadManagementAllDataListShow

}